import PropTypes from 'prop-types';
import theme from '../../../styles/theme';

const Header = ({ children, strong, underline, color, ...props }) => {
  const fontStyle = {
    fontWeight: strong ? 'bold' : 'normal',
    textDecoration: underline ? 'underline' : undefined,
    fontSize: theme.fontSizes.xl,
    color,
  };

  return (
    <h1 {...props} style={{ ...props.style, ...fontStyle }}>
      {children}
    </h1>
  );
};

Header.propTypes = {
  children: PropTypes.node.isRequired,
  strong: PropTypes.bool,
  underline: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.object,
};

Header.defaultProps = {
  strong: true,
  underline: false,
  color: theme.colors.fontBase,
  style: {},
};

export default Header;
